import { concat, isEmpty, get, cloneDeep, filter } from 'lodash';
import type from './ProductCostingType.type';
import { cloneData, Page_Size } from '../../../../Components/helper';

const initialState = {
  bomCompoList: [],
  productCosting: [],
  productCostingDetail: null,
  productCostingPreviousData: null,
  completionData: null,
  productCostingTotalCount: 0,
  allSelectedIds: [],
  costingCommentList: [],
  editCommentData: null,
  productColours: [],
  productLengths: [],
  productSizes: [],
  filterValues: {
    supplier: [],
    colourway: [],
    currency: [],
    incoterms: [],
    searchText: '',
    pageIndex: 1,
    pageSize: Page_Size,
    sortOrder: '',
    sortPropertyName: '',
    loading: false,
    costingStage: [],
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
  },
  productUnitList: [],
  clearedHighlights: false,
  isRefreshed: false,
  productExchnageRate: null,
  costingTemplateDetail: null,
  costingStageListForNonIntegratedSupp: [],
};

const bomSequence = ['Materials', 'Artwork Applications', 'Trims', 'Labels', 'Packaging'];

const ProductCostingReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_TESTING_BOM_LIST:
      let bomUpdatedSequence = [];
      bomSequence.forEach((bom) => {
        const filterSeq = filter(action.payload, function (o) {
          return o.bomType.name === bom;
        });
        if (filterSeq.length > 0) bomUpdatedSequence = concat(bomUpdatedSequence, filterSeq);
      });
      const filterNonSeq = filter(action.payload, function (o) {
        return !bomSequence.includes(o.bomType.name);
      });
      if (filterNonSeq.length > 0) bomUpdatedSequence = concat(bomUpdatedSequence, filterNonSeq);

      return {
        ...state,
        bomCompoList: bomUpdatedSequence,
      };
    case type.LIST_PRODUCT_COSTING:
      const updatedArry = cloneDeep(setArrayByCase(state.productCosting, action.payload));
      return {
        ...state,
        productCosting: updateCostingArray(updatedArry),
        productCostingTotalCount: action.payload.totalCount,
      };
    case type.MAEK_AS_COMPLETE:
      return {
        ...state,
        completionData: action.payload,
      };
    case type.SET_PRODUCT_COSTING_DETAIL_BY_ID:
    case type.SET_UNINTEGRATED_PRODUCT_COSTING_DETAILS:
      return {
        ...state,
        productCostingDetail: action.payload,
      };
    case type.REMOVE_PRODUCT_COSTING:
      const filteredData = state.productCosting.filter(function (item) {
        return action.payload.indexOf(item._id) === -1;
      });
      return {
        ...state,
        productCosting: filteredData,
      };
    case type.DUPLICATE_PRODUCT_COSTING_DETAIL:
      return {
        ...state,
        productCostingPreviousData: action.payload,
      };
    case type.SELECT_ALL_PRODUCT:
      return {
        ...state,
        allSelectedIds: action.payload,
      };
    case type.LIST_PRODUCT_COSTING_COMMENT:
      return {
        ...state,
        costingCommentList: action.payload,
      };
    case type.SET_DATA_TO_UPDATE_COMMENT:
      return {
        ...state,
        editCommentData: action.payload,
      };
    case type.SET_PRODUCT_COLOUR:
    case type.SET_UNINTEGRATED_COLOURWAYS:
      return {
        ...state,
        productColours: action.payload,
      };
    case type.SET_PRODUCT_LENGTHS:
      return {
        ...state,
        productLengths: action.payload,
      };
    case type.SET_PRODUCT_SIZES:
      return {
        ...state,
        productSizes: removeDuplicates(action.payload),
      };
    case type.SET_FILTER_SORT_DATA:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...action.payload },
      };
    case type.SET_UNINTEGRATED_UNITS:
      return {
        ...state,
        productUnitList: action.payload,
      };
    case type.SET_CLEARED_HIGHLIGHTS_STATUS:
      return {
        ...state,
        clearedHighlights: action.payload,
      };
    case type.SET_REFRESHED_STATE:
      return {
        ...state,
        isRefreshed: action.payload,
      };
    case type.SET_PRODUCT_COSTING_EXCHANGE_RATE:
      return {
        ...state,
        productExchnageRate: action?.payload,
      };
    case type.PRODUCT_COSTING_UNMOUNT:
      return {
        ...state,
        ...initialState,
      };
    case type.SET_PRODUCT_COSTING_TEMPLATE_DETAIL_BY_ID:
      console.log('calleddddd', action.payload);
      return {
        ...state,
        costingTemplateDetail: action.payload,
      };
    case type.SET_UNINTEGRATED_COSTINGSTAGE:
      return {
        ...state,
        costingStageListForNonIntegratedSupp: action.payload,
      };

    default:
      return state;
  }
};

const updateCostingArray = (payload) => {
  return cloneData(payload).map((element) => {
    const totalColourway = [];
    const totalDiffQuantity = [];
    const totalDiffPricePerUnit = [];
    element.quantities.forEach((data) => {
      const { expandData } = data;
      const sumOfQuantityPerSizCol = element.isBreakdown ? expandData[0]?.quantityPerSizCol : expandData.reduce((sum, ele) => sum + +ele.quantityPerSizCol, 0);

      totalColourway.push(data.colourway);
      totalDiffQuantity.push(sumOfQuantityPerSizCol);
      data.sumOfQuantityPerSizCol = sumOfQuantityPerSizCol;

      const findColourwayBasedPricePerUnit = element.grandTotal.find((vl) => vl?.colourway === data?.colourway?._id);

      if (findColourwayBasedPricePerUnit) {
        data.colWisePricePerUnit = findColourwayBasedPricePerUnit?.pricePerUnit;
      }
    });

    element.grandTotal.forEach((data) => {
      totalDiffPricePerUnit.push(data?.pricePerUnit);
    });

    return {
      ...element,
      totalColourway,
      totalDiffQuantity,
      totalDiffPricePerUnit,
    };
  });
};

const setArrayByCase = (array, payload) => {
  let newArray;
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    newArray = [...array, ...payload.data];
  } else if (!isEmpty(get(payload, 'searchText'))) {
    newArray = payload.data;
  } else if (get(payload, 'isScrolled')) {
    newArray = concat(array, payload.data);
  } else {
    newArray = payload.data;
  }
  return newArray;
};

function removeDuplicates(arr) {
  return arr?.filter((item, index) => arr?.indexOf(item) === index);
}
export default ProductCostingReducer;
